import React from "react";
import { Link } from 'react-router-dom';
import { baseUrl } from '../../config';
import logo from '../../images/logo.png';
import logo1 from '../../images/logo1.png';

function Footer() {
  return (
    <React.StrictMode>
      <footer>
        <section className="footer-top-wrap">
          <div className="container">
            <div className="row">
              <div className="single-item col-lg-4 col-md-6 col-12">
                <div className="footer-box" style={{ paddingRight: 51 }}>
                  <div className="footer-logo">
                    <Link to={baseUrl + '/'}>
                      <img
                        src={logo1}
                        alt="AdminLTE Logo"
                        className=""
                        style={{ opacity: 0.8 }}
                      />
                    </Link>
                  </div>
                  <div className="footer-about">
                    
                    <div className="footer-social">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-linkedin-in" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-pinterest-p" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-skype" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="single-item col-lg-2 col-md-6 col-12">
                <div className="footer-box">
                  <div className="footer-header">
                    <h3>Platform</h3>
                  </div>
                  <div className="footer-quick-link">
                    <ul>
                      <li>
                        <Link to={baseUrl + '/clinical-intelligence'} onClick={() => window.scrollTo(0, 0)}>
                          Clinical Intelligence
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          How It Works
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/science-of-clinical-intelligence'} onClick={() => window.scrollTo(0, 0)}>
                          Science
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/platform'} onClick={() => window.scrollTo(0, 0)}>
                          Organ Trajectories
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/platform'} onClick={() => window.scrollTo(0, 0)}>
                          Explainability
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="single-item col-lg-2 col-md-6 col-12">
                <div className="footer-box">
                  <div className="footer-header">
                    <h3>Products</h3>
                  </div>
                  <div className="footer-departments">
                    <ul>
                      <li>
                        <Link to={baseUrl + '/predyxiq-quick'} onClick={() => window.scrollTo(0, 0)}>
                          Predyx IQ Quick
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/products'} onClick={() => window.scrollTo(0, 0)}>
                          Predyx IQ
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/products'} onClick={() => window.scrollTo(0, 0)}>
                          Corporate
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/products'} onClick={() => window.scrollTo(0, 0)}>
                          Population
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/products'} onClick={() => window.scrollTo(0, 0)}>
                          Product Roadmap
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="single-item col-lg-2 col-md-6 col-12">
                <div className="footer-box">
                  <div className="footer-header">
                    <h3>Company</h3>
                  </div>
                  <div className="footer-departments">
                    <ul>
                      <li>
                        <Link to={baseUrl + '/about'} onClick={() => window.scrollTo(0, 0)}>
                          About
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/predyxiq-services'} onClick={() => window.scrollTo(0, 0)}>
                          Who We Serve
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/resources'} onClick={() => window.scrollTo(0, 0)}>
                          Resources
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/partnerships'} onClick={() => window.scrollTo(0, 0)}>
                          Partnerships
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/contact'} onClick={() => window.scrollTo(0, 0)}>
                          Contact
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="single-item col-lg-2 col-md-6 col-12">
                <div className="footer-box">
                  <div className="footer-header">
                    <h3>Legal</h3>
                  </div>
                  <div className="footer-departments">
                    <ul>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          Terms of Use
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          Clinical Disclaimer
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          Consent & Data Processing
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          Cookie Policy
                        </Link>
                      </li>
                      <li>
                        <Link to={baseUrl + '/how-it-works'} onClick={() => window.scrollTo(0, 0)}>
                          Data Security
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="footer-center-wrap">
          <div className="container">
            <div className="copyright" style={{ textAlign: 'center' }}>
              © 2026 Predyx. All rights reserved. Predyx provides clinical decision support and preventive health intelligence. It is not a diagnostic tool and does not replace professional medical judgment, clinical evaluation, or personalized treatment.
              <br /><br />
              <a href="https://www.starwebmaker.com/" target="_blank" rel="noopener noreferrer">
                Designed by Star Web Maker
              </a>
            </div>
          </div>
        </section>
      </footer>
    </React.StrictMode>
  );
}

export default Footer;